import { ModalLoaderPayload } from './modal-loader-payload.abstract';
/**
 * Created by 310293471 on 19/03/2018.
 */
export class BasicModalLoaderPayload extends ModalLoaderPayload {
  public content?: string;

  constructor (title: string, content?: string) {
    super(title);
    this.content = content;
  }
  static builder() {
    return new this(null, null);
  }

  setContent(content: string) {
    this.content = content;
    return this;
  }

  setTitle(title: string) {
    this.title = title;
    return this;
  }


}
